import {
  QueryClient,
  QueryKey,
  useQueryClient,
  UseQueryOptions,
} from "@tanstack/react-query";
import { useCallback } from "react";

export const queryOptionsSingleShot = {
  retry: false,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: Infinity,
  gcTime: Infinity,
} satisfies Partial<UseQueryOptions>;

export const invalidateQueryKeys = (
  queryClient: QueryClient,
  ...queryKeys: (readonly [string, ...unknown[]])[]
) =>
  Promise.allSettled(
    queryKeys.map((queryKey) =>
      queryClient.invalidateQueries({
        queryKey,
      }),
    ),
  );

export const useInvalidateQueryKeys = () => {
  const queryClient = useQueryClient();
  const invalidateQuery = useCallback(
    async (...queryKeys: (readonly [string, ...unknown[]])[]) =>
      Promise.allSettled(
        queryKeys.map((queryKey) =>
          queryClient.invalidateQueries({
            queryKey,
          }),
        ),
      ),
    [queryClient],
  );
  return invalidateQuery;
};

// this is a better than invalidateQueryKeys because it removes the cached queries entirely
// invalidation alone causes problems in our app where state does not update reactively (think form state)
// this is better, but could potentially cause other issues if you remove a suspended query for instance
// this is also nice as it will eject all related queries to a query key, regardless of parameters
export const useHardInvalidateQueryKeys = () => {
  const queryClient = useQueryClient();
  const useHardInvalidateQueryKeys = useCallback(
    (...queryKeys: QueryKey[]) => {
      queryKeys.forEach((queryKey) => {
        queryClient.removeQueries({
          predicate: (query) => query.queryKey[0] === queryKey[0],
        });
      });
    },
    [queryClient],
  );

  return useHardInvalidateQueryKeys;
};
